import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { IconButton } from 'react-toolbox/lib/button';
import { Dialog } from 'react-toolbox';
import MessageBox from 'components/MessageBox';
import ColoredButton from 'components/ColoredButton';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import { errorSummary } from '../../../../../../utils';

import modalStyles from 'modal.scss';

export default class InstallCompleteModal extends Resetter(Validator(React.Component)) {

  handleSubmit = () => {
    const { phase, task: { slug }, updatePhaseTask, childHandleTasksClose } = this.props;
    const task = { status: 'complete' };
    updatePhaseTask(
      phase.id,
      slug,
      { task },
    ).then(() => childHandleTasksClose()).then(() => this.handleClose())
      .catch(result => this.setState({ sendError: true, errors: result.payload.errors }));
  }

  handleNoteChange = e => this.setState({ note: e.target.value });

  render(errorMessage = null) {
    const { active, phase } = this.props;
    const { errors, sendError } = this.state;

    return (
      <Dialog
        active={active}
        className={modalStyles.modal}
        type="fullscreen"
        onEscKeyDown={this.handleClose}
        onOverlayClick={this.handleClose}
      >
        {errorMessage && <MessageBox error message={errorMessage} />}
        {sendError && !errorMessage &&
          <MessageBox error message={errorSummary(errors)} />}
        <IconButton
          icon="close"
          className={modalStyles.close}
          onClick={this.handleClose}
          tabIndex={-1}
        />
        <h5 className={modalStyles.title}>Correct Labor Sheet</h5>
        <h5 className={modalStyles.text}>There must not be a labor sheet with $0.00
          unless it&apos;s already marked &#39;Not Payable&#39;. Correct&nbsp;
          <Link
            className={modalStyles.text}
            to={`/phases/${phase.id}/labor-product-accounting/laborsheet`}
            target="_blank"
          >here</Link>.
        </h5>
        <div className={modalStyles.actions}>
          <ColoredButton
            color="green"
            responsive
            label="Complete Task"
            className={modalStyles.button}
            onClick={this.handleSubmit}
          />

          <ColoredButton
            color="darkGray"
            responsive
            label="Cancel"
            className={modalStyles.button}
            onClick={this.handleClose}
          />
        </div>
      </Dialog>
    );
  }
}

InstallCompleteModal.propTypes = {
  active: PropTypes.bool.isRequired,
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  onClose: PropTypes.func.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  addFlagToPhase: PropTypes.func.isRequired,
};

InstallCompleteModal.defaultProps = { active: false };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/installCompleteModal.jsx